import { stringify } from "qs";
import { appPrefixedHost, shopUrlPropertyName, vendorApiRoutePrefix } from "../constants";

export function getSmartrrShopifyAuthenticationRedirectUrl(shopUrl: string) {
  const queryString = stringify(
    {
      ...(shopUrl ? { [shopUrlPropertyName]: shopUrl } : {}),
    },
    { addQueryPrefix: true }
  );

  return `https://${appPrefixedHost}${vendorApiRoutePrefix}/auth/shopify${queryString}`;
}
